import { Link } from 'react-router-dom'

import moment from 'moment'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import type CalendarEvent from 'modules/calendar/store/models/CalendarEvent'
import companyHolidays from 'modules/timeoff/store/collections/companyHolidays'

import styles from './index.module.css'

interface Props {
  event: CalendarEvent
  id: string
  canEditBankHolidays: boolean
}

const CompanyHoliday = ({ event, id, canEditBankHolidays }: Props) => {
  const { navigation } = useNavigation()

  const holiday = companyHolidays.get(id)

  if (!holiday) return null

  const getName = (name: string): string => {
    const date = moment(event.attributes.date)
    const day = date.format('dddd')
    return i18n.t('calendar.event_date_with_name', {
      name,
      day,
    })
  }

  const summary = holiday.attributes.summary

  if (canEditBankHolidays) {
    const to = navigation.settings.locations.locationsId.holidays.fullPath({
      id: holiday.attributes.location_id,
    })

    return (
      <Link key={summary} to={to} className={styles.link}>
        <span>{getName(summary)}</span>
      </Link>
    )
  }

  return (
    <div className={styles.item}>
      <span>{getName(summary)}</span>
    </div>
  )
}

export default observer(CompanyHoliday)
